import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { DistribuicaoLimitesComponent } from "./distribuicao-limites/distribuicao-limites.component";
import { FeaturesResolver } from "src/app/shared/resolvers/features.resolver";
import { DistribuicaoLimitesConfiguracaoComponent } from "./distribuicao-limites-configuracao/distribuicao-limites-configuracao.component";
import { DistribuicaoLimitesDetalhesComponent } from "./distribuicao-limites-detalhes/distribuicao-limites-detalhes.component";
import { DistribuicaoAgentesDetalheComponent } from "./distribuicao-agentes-detalhe/distribuicao-agentes-detalhe.component";

const routes: Routes = [
  {
    path: 'distribuicao-limites',
    component: DistribuicaoLimitesComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      features: FeaturesResolver
    },
    data: { canReuse: false },
  },
  {
    path: 'distribuicao-limites-configuracao',
    component: DistribuicaoLimitesConfiguracaoComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      features: FeaturesResolver
    },
    data: { canReuse: false },
  },
  {
    path: 'distribuicao-limites-detalhes/:id',
    component: DistribuicaoLimitesDetalhesComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      features: FeaturesResolver
    },
    data: { canReuse: false },
  },
  {
    path: 'distribuicao-limites-detalhes/:idCiclo/agente/:idAgenteModalidade',
    component: DistribuicaoAgentesDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      features: FeaturesResolver
    },
    data: { canReuse: false },
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class DistribuicaoLimitesRoutingModule {}
